export const common = {
    appName: "PrestaSlot",
    welcome: "Welcome",
    verify: "Verify",
    verifying: "Verifying...",
    login: "Login",
    signup: "Sign up",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm password",
    rememberMe: "Remember me",
    forgotPassword: "Forgot password?",
    or: "or",
    businessName: "Business name",
    businessType: "Business type",
    termsAccept: "I accept the",
    termsLink: "terms of service",
    privacyAccept: " and the",
    // SEO
    siteTitle: "PrestaSlot - Professional scheduling and reservations",
    siteDescription: "Online organization platform for professionals. Manage your availability, customize your services and receive bookings 24/7.",
    siteKeywords: "professional scheduling, professional reservations, online organization, availability management, service customization, booking 24/7",
    privacyLink: "privacy policy",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Are you a professional and don't have an account yet?",
    loginAction: "Log in",
    signupAction: "Create my professional account",
    features: "Features",
    solutions: "Solutions",
    pricing: "Pricing",
    contact: "Contact",
    proAccount: "Pro Account",
    professional: "Pro Account",
    freeTrial: "And even more ! Join us !",
    seePricing: "See pricing",
    findProfessional: "Find a professional",
    tryForFree: "Try for free",
    hero: "Home",
    testimonials: "Testimonials",
    myAccount: "My Account",
    createPassword: "Create password",
    imageUploadPlaceholder: "Drag and drop an image or click to browse",
    characters: "characters",
    reviewTutorial: "Review tutorial",
    info: "Information for professionals",
    mobileNotAvailable: "Registration or access to the professional dashboard is only available on tablet or PC. The mobile version will be available soon.",
    retry: "Retry",
    close: "Close"
};

export const auth = {
    loginTitle: "Log in to your PrestaSlot account",
    signupTitle: "Sign up to offer your services to your clients",
    loginVisualTitle: "Manage your bookings effortlessly",
    loginVisualText: "Log in to access your dashboard and manage your appointments.",
    signupVisualTitle: "Grow your business",
    signupVisualText: "Join thousands of professionals who trust PrestaSlot to manage their appointments and grow their customer base."
};

export const home = {
    hero: {
        title: "WE BOOST YOUR PROFESSIONAL ORGANIZATION!",
        subtitle: "The ideal solution for you as a beauty professional who wants to focus on your art rather than your organization.",
        trustedBy: "Already used by more than 200 professionals",
        cta: {
            trial: "Optimise your time !",
            demo: "Request a demo"
        }
    },
    features: {
        title: "How we can help you ?",
        subtitle: "Simple and effective tools for you",
        featuresList: {
            dashboard: {
                title: "Intuitive Dashboard",
                description: "Get a quick overview of your daily appointments, revenue, and business statistics at a glance.",
                bullet1: "Track your daily appointments",
                bullet2: "Add new appointments",
                bullet3: "Visualize your revenue"
            },
            calendar: {
                title: "Smart Calendar",
                description: "Manage your schedule with a clear and customizable view of your appointments.",
                bullet1: "View your weekly appointments",
                bullet2: "Cancel appointments",
                bullet3: "Add new appointments"
            },
            services: {
                title: "Service Management",
                description: "Create and customize your services with options, durations, and prices tailored to your business.",
                bullet1: "Add your services with or without options",
                bullet2: "Deactivate services",
                bullet3: "Services without time slots"
            },
            reservation: {
                title: "Reservation Tracking",
                description: "View your complete booking history and easily manage modifications or cancellations.",
                bullet1: "Filter your reservations",
                bullet2: "Analyze your bookings",
                bullet3: "Manage modifications"
            },
            bookingClient: {
                title: "Simplified Client Booking",
                description: "Offer your clients a smooth and intuitive booking experience, accessible 24/7.",
                bullet1: "Book services with or without time slots",
                bullet2: "No payment processing in the app",
                bullet3: "Intuitive interface for clients"
            },
            availability: {
                title: "Availability Management",
                description: "Set up recurring or one-time slots according to your personal schedule.",
                bullet1: "Add recurring time slots",
                bullet2: "Add one-time slots anytime",
                bullet3: "Share your reservation link with your clients",
            }
        },
    },
    businessTypes: {
        title1: "For which professionals ?",
        subtitle: "A solution designed for beauty professionals like you",
        request: "You don't recognize yourself in any of these profiles?",
        text: "Don't worry! PrestaSlot adapts to your business and your specific needs, whatever your specialty. Whether you're a beginner or an expert.",
        hairdressing: {
            title: "Hairdressing",
            description: "Easily manage your appointments and build customer loyalty with personalized reminders"
        },
        aesthetics: {
            title: "Aesthetics",
            description: "Optimize your schedule and offer 24/7 online bookings"
        },
        nails: {
            title: "Nail Prosthetist",
            description: "Organize your calendar and let clients choose their services online"
        },
        makeup: {
            title: "Makeup",
            description: "Manage your bookings for events and individual sessions stress-free"
        },
        cta: {
            text: "Join us !",
        }
    },
    pricing: {
        title: "Simple and transparent pricing",
        subtitle: "14-day free trial, no commitment",
        essential: {
            title: "Essential",
            price: "$19",
            period: "/month",
            features: [
                "Up to 50 bookings/month",
                "Calendar management",
                "Online payments",
                "Email support"
            ],
            button: "Start trial"
        },
        professional: {
            title: "Professional",
            price: "$39",
            period: "/month",
            popular: "Popular",
            features: [
                "Unlimited bookings",
                "Advanced statistics",
                "Customization",
                "Priority support"
            ],
            button: "Start trial"
        },
        enterprise: {
            title: "Enterprise",
            price: "$89",
            period: "/month",
            features: [
                "Multi-users",
                "Dedicated API",
                "Advanced integrations",
                "Dedicated support"
            ],
            button: "Contact us"
        }
    },
    launch: {
        title: "Exclusive Launch",
        subtitle: "Be among the first to transform your business",
        freeAccess: "1 month free",
        description: "To celebrate our launch, we're offering completely free access to all premium features of PrestaSlot. Simplify your appointment management, boost your visibility, and grow your business now.",
        cta: "Get started for free",
        footer: "No credit card required • Full access • No commitment",
    }
}

export const errors = {
    emptyFields: "Please fill in all fields.",
    incorrectPassword: "Incorrect password.",
    passwordsDontMatch: "Passwords do not match.",
    termsNotAccepted: "You must accept the terms of service."
}

export const emailVerification = {
    title: "Check your current email...",
    success: "Email verified successfully!",
    adress: "Your email address",
    suite: "has been verified successfully.",
    connect: "You can now connect to your account.",
    login: "Login",
    alreadyVerified: "Email already verified",
    suite1: "has already been verified.",
    connect1: "You can connect to your account.",
    expired: "Link expired",
    expired1: "The verification link has expired.",
    resend: "Request a new link",
    backToLogin: "Back to login",
    error: "Error",
    error1: "An error occurred while verifying your email.",
}

export const forgotPassword = {
    emailSentTitle: "Email sent",
    emailSentText: "If this email address is associated with an account, you will receive a link to reset your password. Please check your inbox.",
    backToLogin: "Back to login",
    forgotPasswordTitle: "Forgot password",
    forgotPasswordText: "Enter your email address and we will send you a link to reset your password.",
    sendingLink: "Sending link...",
    sendLink: "Send reset password link"
}

export const resetPassword = {
  successTitle: "Password reset successfully",
  successText: "Your password has been reset successfully.",
  connectText: "You can now connect to your account.",
  connectButton: "Connect now",
  forgotPasswordTitle: "Forgot password",
  forgotPasswordText: "Enter your email address and we will send you a link to reset your password.",
  tokenMissing: "Token missing. Please use the link sent by email.",
  resettingPassword: "Resetting password...",
  resetPassword: "Reset password",
  backToLogin: "Back to login",
  verifying: "Verifying link...",
  alreadyUsedTitle: "Link already used",
  alreadyUsedText: "This reset link has already been used or is no longer valid. For security reasons, each link can only be used once.",
  expiredTitle: "Link expired",
  expiredText: "This reset link has expired. Reset links are valid for 1 hour.",
  requestNewLink: "Request a new link"
}

export const footer = {
    product: "Product",
    resources: "Resources",
    company: "Company",
    documentation: "Documentation",
    tutorials: "Tutorials",
    about: "About",
    legal: "Legal",
    contactUs: "Contact us",
    allRightsReserved: "All rights reserved.",
    terms: "Terms of Service",
    privacy: "Privacy Policy"
};

export const sidebar = {
    principal: "Main",
    dashboard: "Dashboard",
    calendar: "Calendar",
    reservations: "Reservations",
    gestion: "Management",
    services: "Services",
    availability: "Availability",
    parametres: "Settings",
    profile: "Profile",
    dark: "Dark",
    logout: "Logout",
    profession: "Job ?",
    billing: "Billing",
    guide_utilisation: "Usage",
    guide: "Guide",
    reviews: "Reviews",
    stripeConnect: "Balance"
};

export const logoutConfirmationModal = {
    title: "Confirmation of logout",
    description: "Are you sure you want to logout?",
    cancel: "Cancel",
    logout: "Logout"
};

export const availability = {
    title: "Availability",
    addSlot: "Add slot",
    endTimeBeforeStartTime: 'End time must be after start time',
    recurringSlots: "Recurring slots",
    textOptionDrawer: "Please select the type of slots",
    recurringSlotsDescription: "Define your weekly slots and their application period",
    startDate: "Start date",
    endDate: "End date",
    startTime: "Start time",
    endTime: "End time",
    oneTimeSlots: "One time slots",
    oneTimeSlotsDescription: "Add slots for specific dates",
    date: "Date",
    noOneTimeSlotAdded: "No one time slot added",
    validate: "Validate",
    dayNames: {
        lun: "Mon",
        mar: "Tue",
        mer: "Wed",
        jeu: "Thu",
        ven: "Fri",
        sam: "Sat",
        dim: "Sun"
    },
    editSlot: "Edit slot",
    deleteSlot: "Delete slot",
    confirmDelete: "Confirm delete",
    confirmDeleteMessage: "Are you sure you want to delete this slot? This action is irreversible.",
    confirmDeleteTitle: "Confirm delete",
    confirmDeleteConfirmText: "Delete",
    confirmDeleteCancelText: "Cancel",
    editSlot1: "Edit recurring slot",
    editSlot2: "Edit slot",
    date_select: "Select a date",
    save: "Save",
    shareLink: "Share your link for booking",
    copied: "Copied!",
    sharelink: "Share link",
    unavailable: "Unavailable",
    timeZone: "Time zone",
    selectSlotType: "Please choose a slot type",
    selectSlotTypeDescription: "Select \"Ponctual\" or \"Recurrent\" to continue",
    add: "Add",
    period: "Period of application of recurring slots",
    fullYear: "Full year",
    fullYearDescription: "These weekly slots will apply from January 1 to December 31",
    customPeriod: "Custom period",
    customPeriodDescription: "Define specific start and end dates for these weekly slots",
    debutDate: "Start date",
    finDate: "End date",
    validation: "Validate"
};

export const services = {
    placeholder: "Search a service...",
    title: "Services",
    titleList: "Services list",
    subtitle: "Manage your services, option categories and options",
    add: "New service",
    retry: "Retry",
    serviceName: "Name",
    serviceDescription: "Description",
    price: "Price (£)",
    duration: "Duration",
    noServicesFound: "No services found",
    noServices: "No services found",
    addService: "Add service",
    editService: "Edit service",
    viewService: "Service details",
    category_temporary: "Temporary category",
    optional: "Optional",
    singleChoice: "Single choice",
    deleteOption: "Delete option",
    deleteCategory: "Delete category",
    reactivateService: "Reactivate service",
    addOption: "Add option",
    editOption: "Edit option",
    viewOption: "Option details",
    optionName: "Name",
    optionNamePlaceholder: "Option name",
    optionDescription: "Description (optional)",
    optionDescriptionPlaceholder: "Option description",
    optionPrice: "Additional price (£)",
    optionImage: "Image (optional)",
    optionImagePlaceholder: "No image",
    optionActive: "Option active",
    browse: "Browse",
    close: "Close",
    cancel: "Cancel",
    create: "Create",
    save: "Save",
    loading: "Loading...",
    addCategory: "Add option category",
    editCategory: "Edit option category",
    categoryName: "Name",
    categoryNamePlaceholder: "Category name",
    categoryDescription: "Description (optional)",
    categoryDescriptionPlaceholder: "Category description",
    categoryPrice: "Additional price (£)",
    categoryImage: "Image (optional)",
    categoryImagePlaceholder: "No image",
    categoryIsActive: "Category active",
    categoryIsRequired: "Option required",
    categoryOptional: "Optional",
    categoryIsMultipleChoice: "Multiple choice allowed",
    errorSubmittingService: "An error occurred while submitting the service",
    imageTooLarge: "The image is too large. Maximum size: 2MB. Current size: {{size}}MB",
    serviceImagePlaceholder: "Drag and drop an image or click to browse",
    requiresBooking: "Requires booking",
    isActive: "Service active",
    reactivate: "Reactivate",
    bookings: "bookings",
    withoutBooking: "Without booking",
    optionCategories: "Option categories",
    categoryInactive: "Inactive",
    optionInactive: "Inactive",
    noCategories: "No option categories for this service",
    update: "Update",
    // New fields for booking settings
    bookingSettings: "Booking Settings",
    minTimeBeforeBooking: "Minimum advance booking time",
    minTimeBeforeBookingHelp: "Minimum time before a client can book (in minutes)",
    bufferTimeBetweenSlots: "Buffer time between appointments",
    bufferTimeBetweenSlotsHelp: "Time automatically added between two appointments (in minutes)",
    noMinTimeSet: "No minimum time set",
    noBufferTimeSet: "No buffer time set",
    
    delete: "Delete",
    activate: "Activate",
    deactivate: "Deactivate",
    deleteTitle: "Delete service",
    deleteMessage: "Are you sure you want to delete this service \"${service.name}\"? This action is irreversible.",
    deleteConfirmText: "Delete",
    deleteCancelText: "Cancel",
    activateConfirmText: "Activate",
    activateCancelText: "Cancel",
    deactivateConfirmText: "Deactivate",
    deactivateCancelText: "Cancel",
    statusFilter: {
        all: "All",
        active: "Active",
        inactive: "Inactive"
    },
    noImage: "No image",
    noDescription: "No description",
    noBookingRequired: "No booking required",
    view: "View",
    edit: "Edit",
    confirmDelete: "Confirm delete",
    deleteConfirmation: "Are you sure you want to delete this service?",
    noOptions: "No options for this category",
    free: "Free",
    serviceImage: "Image",
    addOptionCategoryQuestion: "Do you want to create an option category for this service?",
    categoryWithoutOptionsWarning: "Categories without options will be automatically deleted when this window is closed.",
    createCategory: "Creating...",
    saveCategory: "Saving...",
    required: "Required",
    saving: "Saving...",
    // Collaborators
    assignCollaborators: "Assign collaborators",
    assignCollaboratorsHelp: "Select the collaborators who can perform this service",
    assignedCollaborators: "Assigned collaborators",
    noCollaboratorsAvailable: "No collaborators available",
    viewCollaborators: "View collaborators",
    noneCollaboratorsAssigned: "No collaborators available"
};

export const profile = {
    title: "Profile",
    subtitle: "Manage your preferences and information",
    edit: "Edit",
    personal: "Personal profile",
    business: "Business profile",
    security: "Security",
    subscription: "Subscription",
    language: "Language",
    languageSettings: "Language settings",
    languageDescription: "Manage the language settings of the application",
    languageChoice: "Application language",
    languageFR: "French",
    languageEN: "English",
    updatePreferences: "Update...",
    savePreferences: "Save preferences",
    subscriptionDescription: "Subscription information",
    subscriptionFree: "Free application",
    subscriptionFreeDescription: "For the launch of Presta Slot, the application is entirely free until further notice. Enjoy all features without any restrictions or commitment.",
    subscriptionFreeDescription2: "We will inform you in advance when the paid plans will be available.",
    securityDescription: "Manage your security information",
    changePassword: "Change your password",
    currentPassword: "Current password",
    newPassword: "New password",
    confirmNewPassword: "Confirm new password",
    updatePassword: "Update password",
    newPasswordDescription: "8 characters minimum, with letters and numbers",
    businessDescription: "Manage your business information",
    businessName: "Business name",
    businessDescriptionVisible: "Visible on your public booking page",
    businessAddress: "Address",
    businessPostalCode: "Postal code",
    businessCity: "City",
    businessPhone: "Phone",
    businessEmail: "Email",
    businessLogo: "Logo",
    businessCountry: "Country",
    businessSiren: "SIREN",
    verified: "Verified",
    sirenDescription: "9-digit SIREN number to verify your business",
    changeLogo: "Change logo",
    logoFormat: "PNG, JPG or SVG. 2MB maximum.",
    updateBusiness: "Update business",
    personalDescription: "Manage your personal information",
    firstName: "First name",
    lastName: "Last name",
    phone: "Phone",
    email: "Email",
    profession: "Profession",
    timeZone: "Time zone",
    updatePersonal: "Update personal information",
    professionPlaceholder: "Ex: Hairdresser",
    passwordChangeSuccess: "Your password has been successfully updated. You will be disconnected in a few seconds...",
    redirecting: "Redirecting...",
    businessReservationConditions: "Reservation conditions",
    businessReservationConditionsVisible: "Visible on your public booking page",
    businessReservationConditionsPlaceholder: "Describe your reservation conditions...",
    businessPaymentMethods: "Accepted payment methods",
    businessPaymentMethodsDescription: "This information will be displayed to clients during booking and in reminder emails",
    paymentMethodCash: "Cash",
    paymentMethodCreditCard: "Credit Card",
    paymentMethodBankTransfer: "Bank Transfer",
    paymentMethodCheck: "Check",
    paymentMethodPaypal: "PayPal",
    paymentMethodMobilePayment: "Mobile Payment",
    paymentMethod: "Payment method",

    // Gallery photos
    galleryPhotos: "Photos of the salon",
    mainPhoto: "Main photo",
    replacePhoto: "Replace photo",
    deletePhoto: "Delete photo",
    uploadPhotos: "Add photos",
    selectedPhotos: "Selected photos",
    uploading: "Uploading...",
    photoFormat: "PNG, JPG or WebP. 2MB maximum.",
    addPhotos: "Add photos",
    galleryPhotoInfo: "The first photo will be displayed as the main photo in your gallery.",
    maxPhotos: "Maximum 5 photos.",
};

export const emailVerificationBanner = {
    title: "Verify your email",
    description: "Click on the link in the email to activate your account"
};

export const calendar = {
    title: "Calendar",
    newAppointment: "New appointment",
    cancelAppointment: "Cancel appointment",
    appointmentDetails: "Appointment details",
    cancelAppointmentDescription: "This action is irreversible. The client will be notified of the cancellation.",
    return: "Return",
    confirmCancellation: "Confirm cancellation",
    options: "Options",
    confirmed: "Confirmed",
    cancelled: "Cancelled",
    completed: "completed",
    date: "Date",
    time: "Time",
    clientName: "Client name",
    clientEmail: "Client email",
    clientPhone: "Client phone",
    close: "Close",
    week1: "Week of",
    week: "Week",
    day: "Day",
    day2: "Today",
    week2: "This week",
    booked: "Reserved"
};

export const reservations = {
    title: "Reservations",
    subtitle: "Manage your appointments with your clients",
    loadingDetails: "Loading details...",
    confirmed: "Confirmed",
    cancelled: "Cancelled",
    completed: "Completed",
    dateUnavailable: "Date unavailable",
    timeUnavailable: "Time unavailable",
    phoneNotSpecified: "Phone not specified",
    notSpecified: "Not specified",
    clientNotSpecified: "Client not specified",
    emailNotSpecified: "Email not specified",
    appointmentInfo: "Appointment information",
    serviceNotSpecified: "Service not specified",
    reservationDetails: "Reservation details",
    options: "Options selected",
    cancellationReason: "Cancellation reason",
    specialInstructions: "Special instructions",
    reservationCancelled: "This reservation has been cancelled",
    close: "Close",
    total: "Total",
    currency: "£",
    dateUnknown: "Date unknown",
    timeUnknown: "Time unknown",
    noReservationsFound: "No reservations found",
    actions: "Actions",
    status: "Status",
    date: "Date",
    time: "Time",
    clientName: "Client name",
    service: "Service",
    duration: "Duration",
    price: "Price",
    search: "Search...",
    day: "Day",
    week: "Week",
    month: "1 Month",
    all: "All",
    totalBookings: "Total bookings",
    confirmationRate: "Confirmation rate",
    totalValue: "Total value",
    clientInfo: "Client information"
};

export const dashboard = {
    title: "Dashboard",
    appointmentsOfDay: "Appointments of the day",
    all: "All",
    quickActions: "Quick actions",
    ongoing: "Ongoing",
    upcoming: "Upcoming",
    past: "Past",
    appointments: "appointments",
    greeting: "Hello",
    activity: "here is the activity of",
    noAppointments: "No appointments",
    newAppointment: "New Appointment",
    availability: "Availability",
    revenue: "Revenue",
    revenueTotal: "Total revenue",
    revenueCompleted: "Completed",
    revenueUpcoming: "Upcoming",
    currency: "£",
    close: "Close",
    newAppointment1: "New appointment",
    requiredFields: "Les champs marqués d'un",
    requiredFields2: "sont obligatoires.",
    loadingServices: "Chargement des services...",
    selectService: "Sélectionner un service",
    options: "Options",
    serviceNoBooking: "Ce service ne nécessite pas de réservation de créneau horaire.",
    serviceNoBooking2: "Vous pouvez directement confirmer votre commande. Le prestataire vous contactera prochainement.",
    serviceNoBooking3: "Veuillez sélectionner un service pour continuer",
    serviceNoBooking4: "Veuillez sélectionner une date pour voir les horaires disponibles",
    cancel: "Annuler",
    confirm: "Confirmer",
    loading: "Chargement...",
    loading1: "Chargement des horaires...",
    noSlots: "Aucun créneau disponible pour cette date. Veuillez choisir une autre date ou un autre service.",
    availableSlots: "Horaires disponibles",
    selectOption: "Sélectionner une option",
    cancelAppointment: "Mark as cancelled",
    next: "Next",
    activityHowMany: "There is",
    phone: "Phone",
    email: "Email",
    firstName: "First name",
    lastName: "Last name"
};

export const booking = {
    bookService: "Book a service",
    selectService: "Select a service",
    selectOptions: "Select options",
    selectDateTime: "Select a date and time",
    yourInformation: "Your information",
    confirm: "Confirm booking",
    bookingSuccess: "Booking confirmed!",
    bookingError: "Error booking",
    noServices: "No services available",
    serviceOptions: "Service options",
    totalPrice: "Total price",
    confirmBooking: "Confirm booking",
    loading: "Loading services...",
    bookingDescription: "Select a service, customize your options and book your slot in a few clicks.",
    includingOptions: "Options included",
    confirmationNote: "By confirming, you accept our service terms and conditions.",
    servicesCount: "{{count}} services available",
    howItWorks: "How it works?",
    step1: "1. Choose",
    step1Desc: "Select the service you are interested in",
    step2: "2. Customize",
    step2Desc: "Add options and provide your personal information if necessary",
    step3: "3. Schedule",
    step3Desc: "Choose a date and available time slot",
    step4: "4. Confirm",
    step4Desc: "Confirm your booking and receive a confirmation email",
    bookingConfirmed: "Booking confirmed",
    confirmationEmailSent: "A confirmation email has been sent to you",
    bookingDetails: "Booking details",
    service: "Service",
    date: "Date",
    time: "Time",
    thankYou: "Thank you for your trust. See you soon for your service!",
    options: "Available options",
    multipleChoice: "Multiple choice",
    selectDate: "Select a date",
    clientInfo: "Your information",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone",
    requiredFields: "The fields marked with a * are required",
    privacyNote: "Your personal information will only be used to process your booking and contact you in case of need.",
    importantInfo: "Important information",
    importantInfoText: "The payment is not managed by our platform. Please contact your professional directly to organize the payment of your reservation.",
    reservationConditionsTitle: "Reservation conditions !",
}

export const bookingCancellation = {
  backToHome: "Back to home",
  errorTitle: "Error",
  cancelled: "Booking cancelled",
  details: "Booking details",
  client: "Client",
  date: "Date",
  service: "Service",
  options: "Options selected",
  totalPaid: "Amount paid",
  paidDeposit: "Deposit paid",
  canceling: "Canceling...",
  cancelBooking: "Cancel booking",
  cancelledDone: "Your booking has been successfully cancelled"
}

export const faq = {
    title: "Frequently Asked Questions",
    subtitle: "Find quick answers to your questions",
    categories: {
        client: "For clients",
        professional: "For professionals"
    },
    client: {
        booking: {
            question: "How do I book a slot on PrestaSlot?",
            answer: "To book a slot, first select the desired service, then choose an available slot in the calendar. Complete the form with your contact details and confirm the booking."
        },
        account: {
            question: "Do I need to create an account to book?",
            answer: "No, you don't need to create an account to make a booking. You just need to provide your contact details when making an appointment."
        },
        cancel: {
            question: "How do I cancel or modify a booking?",
            answer: "You can cancel your booking using the link provided in the confirmation email. For any modifications, please contact the professional directly."
        },
        payment: {
            question: "What payment methods are accepted?",
            answer: "Payment methods vary depending on the professional. Details of accepted payment methods should be confirmed with the professional. PrestaSlot does not handle financial transactions between professionals and clients."
        },
        contact: {
            question: "How do I contact a professional after my booking?",
            answer: "You can contact the professional using the contact details provided in your booking confirmation email."
        }
    },
    professional: {
        start: {
            question: "How do I start using PrestaSlot?",
            answer: "Sign up for free, set up your profile and services, then add your availability. You can then share your booking link with your clients."
        },
        trial: {
            question: "How long is the free trial period?",
            answer: "You get a one-month free trial with access to all premium features. No credit card is required to start."
        },
        calendar: {
            question: "Can I sync my existing calendar?",
            answer: "Yes, PrestaSlot syncs with Google Calendar, Apple Calendar, and Outlook. You can set up this synchronization in your account settings."
        },
        notifications: {
            question: "How do automatic reminders work?",
            answer: "Reminders are automatically sent via email and/or SMS according to your preferences. You can customize when they are sent (24h, 12h, or 1h before the appointment)."
        },
        pricing: {
            question: "What are the pricing plans after the trial period?",
            answer: "After the trial period, you can choose between different plans according to your needs. Check our Pricing page for more details."
        }
    },
    cta: {
        text: "Have more questions?",
        button: "Contact us"
    }
}

export const terms = {
    title: "Terms of Service",
    sections: {
      legal: {
        title: "Legal Notice",
        editor: {
          title: "Site Editor",
          content: [
            "PrestaSlot is edited by:",
            "Legal name: Indemba Emmanuel",
            "Legal representative: Indemba Emmanuel",
            "Legal form: Individual Enterprise",
            "SIREN: 903843555",
            "VAT number: FR49903843555",
            "Support service: contact-pro@prestaslot.com"
          ]
        },
        hosting: {
          title: "Hosting",
          content: [
            "PrestaSlot is hosted by:",
            "Vercel Inc.",
            "US-based company (Inc.)",
            "340 S Lemon Ave #4133, Walnut, CA 91789, USA",
            "Phone: (559) 288-7060",
            "Email: privacy@vercel.com"
          ]
        }
      },
      intro: {
        title: "1. Introduction",
        content:
          "Welcome to PrestaSlot. These Terms of Service govern your use of our platform and all associated services. By using our service, you agree to be bound by these terms."
      },
      serviceDescription: {
        title: "2. Service Description",
        content: [
          "PrestaSlot is a SaaS (Software as a Service) online booking platform that allows service providers to manage their availability, receive online payments, and clients to book time slots for different services with or without prior payment.",
          "PrestaSlot provides a technical infrastructure enabling the connection between professionals and clients, secure payment processing via our partner Stripe, calendar management, and automated notifications. We are not responsible for the quality of services provided by professionals or the execution of booked services."
        ]
      },
      usageTerms: {
        title: "3. Usage Terms",
        content: [
          "To use our service, you must be at least 18 years old or have reached the legal age of majority in your jurisdiction. Parents or legal guardians may make bookings for minors under their responsibility. You are responsible for maintaining the confidentiality of your account and password.",
          "Professionals must provide accurate and up-to-date information, including: name, first name, profession, email, phone number, company name, SIREN number (mandatory for legitimacy verification), description, complete address, and time zone. Clients must provide at minimum their first name, last name, and email (phone number is optional).",
          "Professionals agree not to use the platform for illegal, fraudulent, or unethical purposes. PrestaSlot reserves the right to suspend or delete any professional account in case of violation of these terms."
        ]
      },
      personalData: {
        title: "4. Personal Data",
        content: [
          "By using our service, you accept that we collect and use your personal data in accordance with our Privacy Policy available on our website.",
          "For clients, we collect: first name, last name, email, phone number (optional), booking history, and in case of online payment, a Stripe customer ID (no banking data is stored on our servers). For professionals, we collect additional information including SIREN number, Stripe identifiers for subscriptions and payments, and service configuration preferences."
        ]
      },
      subscriptions: {
        title: "5. Professional Subscriptions",
        content: [
          "PrestaSlot offers three monthly subscription plans for professionals: Junior (€14.99/month), Premium (€34.99/month), and Premium Plus (€49.99/month). Each plan offers different features and limits (number of salons, collaborators, access to online payments, review system, etc.).",
          "Trial period: All new professionals benefit from a free 14-day trial period.",
          "Renewal and cancellation: Subscriptions are for an indefinite period with automatic monthly renewal. You can cancel your subscription at any time from your professional space or via the Stripe billing portal. Cancellation will take effect at the end of the current billing period, without pro-rata refund.",
          "Plan modification: You can change your plan at any time (upgrade or downgrade). In case of upgrade, the difference will be charged pro-rata. In case of downgrade, the change will take effect at the next billing period.",
          "Non-payment: In case of payment default, your account will be suspended after 7 days. If payment is not regularized within 30 days, your account will be permanently deleted and your data archived in accordance with our legal obligations."
        ]
      },
      payments: {
        title: "6. Online Payments and Billing",
        content: [
          "Payment provider: PrestaSlot uses Stripe as the sole secure payment provider to process all transactions between clients and professionals. Stripe is PCI-DSS Level 1 certified, the highest level of payment security compliance. No banking data (card number, CVV, etc.) is stored on PrestaSlot's servers.",
          "Payment types: Professionals can configure three payment modes for their services: (1) Deposit - the client pays a percentage or fixed amount defined by the professional (e.g., 30% or €15), (2) Full payment - the client pays the total service amount when booking, (3) No online payment - the booking is confirmed without prior payment, with payment made directly with the professional.",
          "Service fees: Stripe applies service fees of approximately 1.5% + €0.25 per payment. The professional can choose to absorb these fees (the client pays the displayed service price) or pass them on to the client (slightly higher amount charged to the client to cover service fees). This choice is configurable in professional account settings.",
          "Stripe Connect: Professionals must create a Stripe Connect account to receive payments from their clients. The identity verification process required by Stripe is mandatory to comply with anti-money laundering regulations. Funds are transferred to the professional's bank account according to Stripe's timelines (generally within 2 to 7 business days).",
          "Refunds: In case of cancellation of a booking with payment, the refund is subject to conditions defined by the professional. If the service provides automatic refund in case of cancellation before a certain deadline (e.g., 24 hours before), the refund will be made automatically via Stripe. The refunded amount will correspond to the net amount received by the professional (after service fees deduction). Service fees are never refunded by Stripe upon refund.",
          "Subscription billing: Professional subscription invoices are automatically generated by Stripe and sent by email. You can access the complete history of your invoices via the Stripe billing portal accessible from your professional space.",
          "Promo codes: Professionals can create promotional codes offering discounts (percentage or fixed amount) on their services. Codes can be limited to specific clients or services, with defined validity dates. Each client can use a promo code only once."
        ]
      },
      accountManagement: {
        title: "7. Account Management",
        content: [
          "Client accounts: Clients do not need to create an account to make a booking. They simply provide their contact details (first name, last name, email, optional phone) with each booking. A unique identifier is automatically created to ensure booking and payment tracking.",
          "Professional accounts: Professionals have a password-secured account to manage their services, availability, bookings, and subscription settings. The password is stored in hashed form (bcrypt) and is never accessible in clear text, even by our teams.",
          "Professional account deletion: To delete your professional account, contact our customer service via chatBot or at contact-pro@prestaslot.com. Deletion will result in: (1) immediate cancellation of your subscription without refund, (2) deactivation of your services and availability, (3) archiving of your booking and payment data for the mandatory legal period (5 to 10 years for tax data), (4) permanent deletion of your personal data after this period. Important: certain data is retained to comply with legal and accounting obligations.",
          "Booking cancellation: Clients can cancel their bookings via the secure link received by email upon confirmation. According to the cancellation policy defined by the professional, an automatic refund may be made. Professionals can also cancel bookings from their space, in which case the client is automatically notified and refunded if a payment had been made."
        ]
      },
      intellectualProperty: {
        title: "8. Intellectual Property",
        content: [
          "Platform content: All elements of the PrestaSlot platform (design, source code, logo, texts, graphics, user interface) are the exclusive property of PrestaSlot or its partners and are protected by French and international intellectual property laws. Any unauthorized reproduction, distribution, or use is strictly prohibited.",
          "Content created by professionals: Professionals retain all intellectual property rights to content they create and publish on the platform (service descriptions, photos, company logos, etc.). By publishing this content, you grant PrestaSlot a worldwide, non-exclusive, transferable, and royalty-free license to use, reproduce, display, and distribute this content only within the framework of providing and promoting our services.",
          "Client reviews: Reviews and comments published by clients belong to their authors. By publishing a review, you grant PrestaSlot the right to display it publicly on the platform and use it for promotional purposes. PrestaSlot reserves the right to moderate or remove any inappropriate, defamatory content or content contrary to our terms of use."
        ]
      },
      responsibility: {
        title: "9. Professional Responsibility",
        content: [
          "Each professional is solely responsible for the services they offer, their accurate description, availability, compliant execution, and compliance with applicable laws and regulations. The professional guarantees that they have all legal authorizations, licenses, professional insurance, and qualifications necessary to practice their activity.",
          "The professional commits to providing a valid SIREN number and maintaining their legal information up to date. PrestaSlot reserves the right to verify the SIREN validity via official services (INPI, INSEE) and suspend any account whose information would be fraudulent or unverifiable.",
          "The professional is responsible for managing their calendar, availability, and appointment confirmation. In case of no-show or last-minute cancellation by the professional, they must manage directly with the client any potential compensation."
        ]
      },
      liability: {
        title: "10. Limitation of Liability",
        content: [
          "Intermediary role: PrestaSlot acts solely as a technical platform connecting professionals and clients. We cannot be held liable for the quality, safety, legality, or any other aspect of services provided by professionals, nor for disputes, claims, damages, or losses resulting directly or indirectly from these services.",
          "Service availability: We strive to maintain the platform accessible 24/7, but cannot guarantee uninterrupted availability. Interruptions may occur for maintenance, updates, or force majeure. PrestaSlot cannot be held responsible for financial losses or other damages resulting from temporary service unavailability.",
          "Payments and transactions: PrestaSlot cannot be held responsible for malfunctions, delays, or errors related to Stripe payment service. In case of payment dispute, the client or professional must contact Stripe or their bank directly. Our responsibility is limited to providing the technical infrastructure enabling connection to Stripe.",
          "Warranty limitation: The platform is provided \"as is\" without warranty of any kind, express or implied. We do not guarantee that the service will be error-free, virus-free, or other harmful elements. PrestaSlot's liability is limited to the amount of subscription fees paid by the professional over the past 12 months."
        ]
      },
      reporting: {
        title: "11. Reporting and Moderation",
        content: [
          "If you encounter a problem with a professional (failure to meet commitments, inappropriate behavior, suspected fraud, etc.), please report it immediately via the chatBot available on our platform or by email at contact-pro@prestaslot.com. All complaints will be examined promptly.",
          "PrestaSlot reserves the right to suspend or permanently delete any professional account subject to recurring complaints or fraudulent behavior, without notice or refund of the current subscription. In case of deletion for serious misconduct, pending transfer funds may be blocked during the investigation.",
          "Fake reviews: The publication of fake reviews (positive or negative) is strictly prohibited. We reserve the right to delete any suspicious review and sanction accounts involved in such practices."
        ]
      },
      changes: {
        title: "12. Changes to Terms",
        content: [
          "PrestaSlot reserves the right to modify these Terms of Service at any time to reflect changes in our service, legislation, or for any other legitimate reason. Users will be informed of significant changes by email to the address registered in their account and/or by notification on the platform at least 30 days before the modifications take effect.",
          "Continued use of our services after the new terms take effect constitutes acceptance thereof. If you do not accept the new terms, you can terminate your account in accordance with the provisions in Article 7."
        ]
      },
      contact: {
        title: "13. Contact",
        content: [
          "For any questions regarding these Terms of Service, you can contact us:",
          "• Via the chatBot available on our platform",
          "• By email: contact-pro@prestaslot.com",
        ]
      },
      updatedAt: "Last updated: January 14, 2026"
    }
  }

  export const privacy = {
    title: "Privacy Policy",
    updatedAt: "Last updated: January 14, 2026",
    sections: {
      introduction: {
        title: "1. Introduction",
        content: "At PrestaSlot, we place great importance on the protection of your personal data. This privacy policy explains how we collect, use, share, and protect your information when you use our online booking platform. By using PrestaSlot, you accept the practices described in this policy."
      },
      responsable: {
        title: "2. Data Controller",
        content: [
          "The controller of your personal data is:",
          "Indemba Emmanuel - PrestaSlot",
          "SIREN: 903843555",
          "Email: contact-pro@prestaslot.com",
          "For any question regarding the protection of your personal data, you can contact us at the above coordinates."
        ]
      },
      collectedData: {
        title: "3. Data Collected",
        intro: "Depending on your status (client or professional), we collect different categories of personal data:",
        clients: {
          title: "A. For clients:",
          items: [
            "Identification data: First name, last name, email address",
            "Contact data: Phone number (optional)",
            "Booking data: Booking history, booked services, selected options, notes or comments",
            "Payment data: Stripe customer ID (stripeCustomerId), transaction history, amounts paid, promo codes used. Important: No banking data (card number, CVV, expiration date) is stored on our servers",
            "Review data: Ratings (1 to 5 stars), comments written about received services",
            "Technical data: IP address, browser type, operating system (via server logs)"
          ]
        },
        professionals: {
          title: "B. For professionals:",
          items: [
            "Identification data: Last name, first name, email address, password (hashed with bcrypt)",
            "Professional data: SIREN number (mandatory), company name, legal form, intra-community VAT number",
            "Contact details: Phone number, complete business address (street, city, postal code, country)",
            "Banking and payment data: Stripe customer ID for subscription (stripeCustomerId), Stripe Connect account ID to receive payments (stripeConnectedAccountId), Stripe account verification status, service fee absorption preference",
            "Subscription data: Subscribed plan (Junior/Premium/Premium Plus), subscription status, trial period start and end date, billing history",
            "Created content: Service descriptions, photos and images (company logo, gallery, service images), availability and time slots, booking and cancellation conditions, created promo codes",
            "Preferences: Interface language, time zone, notification settings",
            "Technical data: IP address, browser type, connection logs"
          ]
        },
        note: "Important: Clients do not need to create an account to make a booking. A unique identifier is automatically assigned to them during their first booking to ensure tracking. No banking data (credit card, IBAN, etc.) is ever stored on PrestaSlot's servers; this information is exclusively processed and secured by our partner Stripe, PCI-DSS Level 1 certified."
      },
      purposes: {
        title: "4. Processing Purposes and Legal Bases",
        intro: "We use your personal data for the following purposes, based on the legal grounds indicated:",
        items: [
          "Booking management (Legal basis: Contract performance): Enable appointments between professionals and clients, send booking confirmations by email, manage cancellations and modifications",
          "Payment processing (Legal basis: Contract performance): Process online payments via Stripe, manage deposits and full payments, process refunds in case of cancellation, apply promotional codes",
          "Professional subscription management (Legal basis: Contract performance): Bill monthly subscriptions, manage trial periods, allow plan changes (upgrade/downgrade), suspend or terminate accounts in case of non-payment",
          "Communication with users (Legal basis: Contract performance and legitimate interest): Send booking confirmation emails, send appointment reminders (if enabled by professional), send review requests after service, send cancellation notifications, communicate important service information",
          "Legitimacy verification (Legal basis: Legal obligation and legitimate interest): Verify SIREN number validity via official services (INPI, INSEE), ensure professionals legally practice their activity, fight fraud and abusive uses",
          "Client review system (Legal basis: Legitimate interest): Allow clients to rate and comment on received services, allow professionals to respond to reviews, publicly display reviews to help other clients in their choice",
          "Service improvement and personalization (Legal basis: Legitimate interest): Analyze platform usage to improve user experience, develop new features, fix bugs and technical issues, adapt interface according to language preferences",
          "Compliance with legal obligations (Legal basis: Legal obligation): Retain billing and payment data in compliance with tax and accounting obligations, respond to judicial requisitions or requests from competent authorities, fight money laundering and terrorism financing (via Stripe verification)"
        ],
        note: "Important: Contrary to what was previously indicated, PrestaSlot now directly intervenes in financial transactions by providing technical infrastructure in partnership with Stripe. However, we never store sensitive banking data (card numbers, etc.)."
      },
      sharing: {
        title: "5. Data Sharing and Communication",
        intro: "Your personal data may be shared with the following recipients:",
        items: [
          "A. Between platform users: When a client makes a booking, the concerned professional receives client information (last name, first name, email, phone if provided, possible note). Clients access public professional information (company name, address, services, client reviews, availability).",
          "B. Stripe (payment provider): For online payments: Client IDs, emails, transaction amounts, booking metadata. For professional subscriptions: Emails, billing information, subscribed plan. For Stripe Connect: Company information (SIREN, address, name), identity verification data (required by Stripe for anti-money laundering compliance). Stripe is PCI-DSS Level 1 certified and GDPR compliant (privacy policy available at stripe.com).",
          "C. Email sending services (Resend or Nodemailer): Recipient emails, names, HTML email content (confirmations, reminders, reviews, password reset). These providers act as processors in compliance with GDPR.",
          "D. AWS S3 (file storage): Images uploaded by professionals (logos, service photos, gallery). Hosting in EU region (eu-north-1) for GDPR compliance. Images are optimized and stored in multiple sizes.",
          "E. INPI (National Institute of Industrial Property): Professional SIREN numbers, sent only to verify company legitimacy during registration.",
          "F. Vercel (frontend hosting): Hosts client application code and static assets. No personal data is directly transmitted, except standard connection logs (IP, user-agent).",
          "G. Competent authorities: In case of legal obligation, judicial requisition, or to protect our rights, we may communicate your data to authorities (police, justice, tax administration, CNIL)."
        ],
        note: "Important: We NEVER sell your personal data to third parties for commercial purposes. We only share your data with providers strictly necessary for service operation and who commit to respecting GDPR."
      },
      security: {
        title: "6. Data Security",
        content: [
          "We implement strict technical and organizational security measures to protect your personal data against any unauthorized access, loss, or disclosure.",
          "All communications between your browser and our servers are encrypted (HTTPS protocol). Your passwords are never stored in clear text and are secured by cryptographic hashing. No banking data (card number, complete IBAN, CVV) is stored on our servers: all payments are processed directly by Stripe, certified to the strictest banking security standards (PCI-DSS Level 1).",
          "Professionals can only access their own data and their clients' data. Access to our database is strictly controlled and our teams are trained in data protection best practices."
        ],
        note: "Despite all these measures, no system is completely infallible. In case of personal data breach likely to present a high risk to your rights and freedoms, we will inform you as soon as possible in compliance with GDPR and notify CNIL within 72 hours."
      },
      retention: {
        title: "7. Data Retention Period",
        intro: "We retain your personal data only for the duration necessary for the purposes for which it was collected, in compliance with legal obligations:",
        items: [
          "Active professional accounts: Throughout your subscription and until account deletion. In case of inactivity (no connection for 3 years), we will contact you before any deletion.",
          "Client data (bookings): 3 years after last booking (duration necessary for claim management and contractual liability).",
          "Payment and billing data: 10 years from the end of the accounting year, in compliance with tax and accounting obligations (articles L123-22 of the Commercial Code). This includes: subscription invoices, payment history, refunds, Stripe data.",
          "Passwords and tokens: Hashed passwords are retained as long as the account exists. JWT tokens automatically expire (1h for access token, 7d for refresh token).",
          "Images and files (AWS S3): Retained as long as professional account is active. Deleted within 30 days following account deletion (except legal retention obligation).",
          "Client reviews: Retained indefinitely as long as professional account exists, as they constitute public reputation element. Deleted only upon motivated request or professional account deletion.",
          "Logs and technical data: Maximum retention of 30 days for connection and usage logs, except in case of security incident requiring investigation.",
          "Data after account deletion: After professional account deletion, certain data is retained in archive to respect legal obligations (invoices, payment history for 10 years). Personal data not subject to legal obligation is permanently deleted within 30 days."
        ],
        note: "Upon expiration of retention periods, your data is either permanently deleted or irreversibly anonymized (meaning it can no longer be linked to your identity). Professionals and clients can request early deletion of their data by contacting us via chatBot or at contact-pro@prestaslot.com, subject to legal retention obligations."
      },
      rights: {
        title: "8. Your Rights (GDPR)",
        intro: "In accordance with the General Data Protection Regulation (GDPR) and the Data Protection Act, you have the following rights concerning your personal data:",
        items: [
          "Right of access (art. 15 GDPR): You can obtain confirmation that your data is being processed, access your personal data and receive a copy thereof. You can also obtain information about processing purposes, data categories, recipients, retention periods.",
          "Right to rectification (art. 16 GDPR): You can request correction of inaccurate or incomplete data concerning you. Professionals can directly modify most of their information from their personal space.",
          "Right to erasure / right to be forgotten (art. 17 GDPR): You can request deletion of your data in certain cases (unnecessary data, consent withdrawal, objection to processing, unlawful processing). Caution: this right is not absolute and may be limited by our legal obligations (retention of invoices for 10 years, for example).",
          "Right to restriction of processing (art. 18 GDPR): You can request temporary freezing of data processing in certain situations (accuracy dispute, unlawful processing but opposition to erasure, data necessary for legal action).",
          "Right to data portability (art. 20 GDPR): You can receive your data in a structured, commonly used, machine-readable format (JSON, CSV) and transmit it to another controller. This right only applies to data you have provided and whose processing is based on your consent or a contract.",
          "Right to object (art. 21 GDPR): You can object to processing of your data for reasons relating to your particular situation, especially when processing is based on our legitimate interest. You can also object to processing for direct marketing purposes (if applicable).",
          "Right not to be subject to automated decision-making (art. 22 GDPR): You have the right not to be subject to a decision based solely on automated processing producing legal effects concerning you. Note: PrestaSlot does not use fully automated decision-making.",
          "Right to define post-mortem directives (art. 40-1 Data Protection Act): You can define directives regarding the fate of your data after your death."
        ],
        contact: "To exercise one of these rights or for any question concerning the protection of your personal data, you can contact us: • Via the chatBot available on our platform • By email: contact-pro@prestaslot.com • By mail: PrestaSlot - Indemba Emmanuel, [complete address]. We commit to responding to your request within a maximum of one month. This deadline may be extended by two months considering the complexity and number of requests. We may ask you for proof of identity to process your request and avoid any usurpation.",
        complaint: "Right to lodge a complaint with supervisory authority: If you believe your rights are not respected or that the processing of your personal data is not GDPR compliant, you have the right to lodge a complaint with the Commission Nationale de l'Informatique et des Libertés (CNIL): • Online: www.cnil.fr • By mail: CNIL - 3 Place de Fontenoy - TSA 80715 - 75334 PARIS CEDEX 07 • By phone: 01 53 73 22 22"
      },
      cookies: {
        title: "9. Cookies and Local Storage",
        content: [
          "PrestaSlot uses local storage technologies in your browser to ensure proper platform operation and improve your user experience.",
          "We store session information in your browser (localStorage) to keep you logged in while navigating the platform, as well as your language preferences (French or English). This information does not contain any sensitive data.",
          "During the payment process, Stripe cookies may be placed to secure your transactions. See Stripe's cookie policy at stripe.com. Our hosting provider (Vercel) may also generate technical cookies for security and performance reasons.",
          "You can delete this data at any time by logging out of your account or clearing your browser cache."
        ],
        note: "PrestaSlot does NOT use tracking or targeted advertising cookies (Google Analytics, Facebook Pixel, etc.). Local storage is limited to what is strictly necessary for service operation."
      },
      updates: {
        title: "10. Privacy Policy Modifications",
        content: [
          "We may update this privacy policy from time to time to reflect changes in our service, applicable legislation (GDPR, Data Protection Act), or our data processing practices.",
          "In case of substantial modification (new processing purposes, new data recipients, changes affecting your rights), we will inform you by email to the address registered in your account and/or by visible notification on the platform, at least 30 days before changes take effect.",
          "Minor modifications (typographical corrections, clarifications, contact updates) will simply be published on this page with update of the \"Last updated\" date at the top of this policy.",
          "We encourage you to regularly consult this page to stay informed about how we protect your personal data. Continued use of our services after substantial modifications take effect constitutes acceptance of the new privacy policy."
        ]
      },
      minors: {
        title: "11. Protection of Minors",
        content: [
          "PrestaSlot is a service intended for adults (18 years and over). We do not knowingly collect personal information directly from minors without consent from a parent or legal guardian.",
          "Bookings for minors: Parents or legal guardians may make bookings for services intended for minors (for example, a parent booking an appointment for their minor child). In this case, it is the parent/guardian who provides personal data and acts on behalf of the minor under their responsibility.",
          "If we learn that we have collected personal data directly from a user under 18 years without verifiable parental consent, we will immediately take measures to delete this information from our servers.",
          "If you are a parent or legal guardian and learn that your child has provided us with personal data without your consent, please contact us immediately at contact-pro@prestaslot.com so we can take appropriate measures."
        ]
      },
      international: {
        title: "12. International Data Transfers",
        content: [
          "Data location: Our main servers and PostgreSQL database are hosted in the European Union. Files (images) are stored on AWS S3 in EU region (eu-north-1, Sweden).",
          "Transfers to the United States: Some of our technical providers are based in the United States: Stripe Inc. (payments and subscriptions): Stripe is GDPR compliant certified and applies Standard Contractual Clauses (SCC) approved by the European Commission to frame data transfers. Privacy policy: stripe.com/privacy. Vercel Inc. (frontend hosting): Personal data is not directly stored at Vercel, only application code and static assets. Connection logs (IP, user-agent) may be collected according to their policy.",
          "Appropriate safeguards: For all data transfers outside the European Union, we ensure appropriate safeguards are in place in accordance with Article 46 GDPR (Standard Contractual Clauses, certifications, transfer agreements)."
        ]
      },
      contact: {
        title: "13. Contact and Data Protection Officer",
        content: [
          "For any question concerning this privacy policy, the processing of your personal data or the exercise of your GDPR rights, you can contact us:",
          "Data Controller: Indemba Emmanuel - PrestaSlot",
          "Email: contact-pro@prestaslot.com",
          "Via the chatBot available on our platform",
          "Note: Given the size of our organization, we have not appointed a dedicated Data Protection Officer (DPO). The data controller fulfills this function himself."
        ]
      }
    }
  }

export const onboarding = {
    dashboard: {
        left: "Welcome to your dashboard! Here, you have all your appointments of the day filtered by status. By clicking on the three dots of the appointment, you can cancel the appointment or mark it as completed.",
        right: "Here, you can create a new appointment.",
        bottom: "Here, you can see your availability.",
        revenue: "Here, you can see your daily revenue.",
    },
    calendar: {
        left: "Here, you can see all your appointments on an unlimited period and switch between the week view and the day view.",
        right: "Here, you can add an appointment. Appointments are displayed in cells, you can select one and cancel it if you want.",
    },
    reservation: {
        left: "Your appointments are displayed here. You can click on an appointment or the three dots to see its details.",
        filterWeek: "You can filter your appointments by day, week and month.",
        filterStatus: "Filter your appointments by status.",
        stats: "Finally, you can see the statistics of your appointments based on the previous filters.",
    },
    services: {
        filterStatus: "Filter your services by status.",
        filterSearch: "You can search for a service.",
        view: "Your services are displayed here. You can click on an appointment or the three dots to see its details.",
        add: "Click on this button to add a service, then you can add categories that will group service options (adding categories and options is optional).",
    },
    profile: {
        update: "Click on this button to update your profile.",
        personalInfo: "Enter your siren, the rest of the information will be pre-filled. Be sure to fill in the rest of the personal information in the Personal profile section. The default timezone is Europe/Paris, but you can change it if you wish.",
    },
    availability: {
        timezone: "Your timezone is displayed here, you can modify it via your profile if you want.",
        link: "Your booking link is displayed here, you can copy it and share it on your profiles to enable customers to book appointments.",
        add: "Click on this button to add your recurring slots or one-off slots.",
        view: "Your slots are displayed here. Your recurring slots are displayed in green and your one-off slots in blue.",
        navigate: "You can navigate between months via the navigation buttons to view your slots over an unlimited period.",
    },
    skip: "Skip the tutorial",
    next: "Next",
    back: "Back",
    close: "Close",
    last: "Finish"
}

export const reviews = {
  // review client
  missingToken: "The token is missing",
  title: "Give your opinion!",
  rateExperience: "Rate your experience",
  commentPlaceholder: "Share your experience (optional)",
  submit: "Sending...",
  send: "Send",
  loading: "Loading...",
  tokenExpired: "The link has expired",
  tokenUsed: "You have already left a review",
  tokenInvalid: "The link is invalid",
  tokenExpiredMessage: "The link for leaving your review has expired. Links are valid for 7 days after your appointment.",
  tokenUsedMessage: "You have already left a review for this appointment. Thank you for your participation!",
  tokenInvalidMessage: "The link you used is not valid. Please check the URL or contact the professional.",
  thankYou: "Thank you for your review!",
  feedbackReceived: "Your feedback has been received and will be visible soon.",
  previous: "Previous page",
  next: "Next page",
  noReviews: "No reviews yet",
  basedOn: "Based on {{count}} reviews",
  ratingDistribution: "Rating distribution",
  titleReview: "Client reviews",
  description: "Discover what our clients think about this professional and their services.",
  bookNow: "Book now",
  professionalReply: "Professional reply",
  noProfessionalId: "Professional ID is missing",
  titleProReview: "Reviews client | PrestaSlot",
  titleWithProName: "Reviews for {{name}}",
  withProfessional: "Consult the verified reviews for {{name}}. Average {{average}}/5 based on {{count}} reviews.",
  general: "Consult the verified reviews of our professionals on PrestaSlot.",
  viewAll: "View all reviews",

  // review pro
  pageTitle: "Client reviews",
  refreshing: "Refreshing...",
  refresh: "Refresh",
  bookingDate: "Booking date",
  yourReply: "Your reply",
  modifyReply: "Modify my reply",
  replyReview: "Reply to this review",
  writeYourReply: "Write your reply here...",
  sending: "Sending...",
  cancel: "Cancel",
  search: "Search reviews...",
  filter: {
    all: "All reviews",
    withResponse: "With response",
    withoutResponse: "Without response"
  },
  noReviewsFound: "No reviews found",
  displaying: "Displaying",
  of: "of",
  reviews: "reviews",
  noStats: "No statistics available",
  stats: "Statistics of reviews",
  totalReviews: "reviews total"
}

export const subscription = {
  title: "Subscription",
  subtitle: "Manage your subscription and choose the plan that suits you",
  loading: "Loading...",

  // Plans
  choosePlanTitle: "Choose your plan",
  choosePlanDescription: "Select the plan that best fits your needs",
  changePlanTitle: "Change plan",
  changePlanDescription: "Upgrade or downgrade according to your needs",

  // Plan Card
  popular: "Popular",
  current: "Current",
  currentPlan: "Current plan",
  currentPlanTitle: "Your current subscription",
  selectPlan: "Select this plan",
  contactUs: "Contact us",
  customPrice: "Custom pricing",
  perMonth: "/month",

  // Features
  features: {
    companies: "{{count}} company",
    companies_plural: "{{count}} companies",
    collaborators: "{{count}} collaborator",
    collaborators_plural: "{{count}} collaborators",
    services: "{{count}} service",
    services_plural: "{{count}} services",
    bookings: "{{count}} bookings/month",
    bookingsUnlimited: "Unlimited bookings",
    promoCodes: "{{count}} active promo code",
    promoCodes_plural: "{{count}} active promo codes",
    promoCodesUnlimited: "Unlimited promo codes",
    onlinePayment: "Online payment",
    depositPayment: "Deposit payment",
    reviewSystem: "Review system",
    advancedAnalytics: "Advanced analytics",
    customBranding: "Custom branding",
    prioritySupport: "Priority support",
    apiAccess: "API access",
    whiteLabel: "White Label"
  },

  // Status
  status: {
    active: "Active",
    trialing: "Trial period",
    pastDue: "Past due",
    canceled: "Canceled",
    incomplete: "Incomplete"
  },

  // Actions
  managePlan: "Manage your plan and options",
  manageBilling: "Manage billing",
  changeSubscription: "Change subscription",
  cancelPlan: "Cancel subscription",
  reactivate: "Reactivate",
  yourPlan: "Your plan",
  billingPeriod: "Billing period",
  trialEnds: "Trial ends",

  // Messages
  successTitle: "Subscription activated!",
  successMessage: "Your subscription has been successfully activated. You can now enjoy all the features of your plan.",
  validUntil: "Valid until {{date}}",
  cancelWarning: "Subscription being canceled",
  cancelDescription: "Your subscription will remain active until {{date}}",

  // Confirmations
  confirmChange: "Are you sure you want to change plans?",
  confirmUpgrade: "Upgrading to this plan will immediately increase your limits. Continue?",
  confirmDowngrade: "Downgrading your plan may limit some features. Are you sure?",
  changePlanConfirmTitle: "Change plan",
  changePlanConfirmYes: "Yes, change",
  changePlanConfirmNo: "No, cancel",
  cancelConfirmTitle: "Cancel subscription",
  cancelConfirmMessage: "Your subscription will remain active until the end of the current period. You can reactivate it at any time.",
  cancelConfirmYes: "Yes, cancel",
  cancelConfirmNo: "No, keep",

  // Plan Multi
  multiPlanDescription: "Custom pricing based on your needs",
  multiContactBody: "Hello! I am interested in the Multi plan and would like to get a custom quote. Can you help me?",

  // Limits
  limits: {
    usage: "Usage",
    upgrade: "Upgrade my plan",
    upgradeTitle: "Benefits of a higher plan",
    benefit1: "Increase your limits immediately",
    benefit2: "Access advanced features",
    benefit3: "Grow your business without constraints",
    cancel: "Not now",

    companies: {
      title: "Company limit reached",
      description: "You have reached the limit of {{limit}} company(ies) for your current plan ({{current}}/{{limit}})."
    },
    collaborators: {
      title: "Collaborator limit reached",
      description: "You have reached the limit of {{limit}} collaborator(s) for your current plan ({{current}}/{{limit}})."
    },
    services: {
      title: "Service limit reached",
      description: "You have reached the limit of {{limit}} service(s) for your current plan ({{current}}/{{limit}})."
    },
    promoCodes: {
      title: "Promo code limit reached",
      description: "You have reached the limit of {{limit}} active promo code(s) for your current plan ({{current}}/{{limit}})."
    },
    generic: {
      title: "Limit reached",
      description: "You have reached the limit of your current plan ({{current}}/{{limit}})."
    }
  }
}

export const billing = {
  title: "Billing",
  subtitle: "Manage your invoices and payment methods",

  // Subscription Management
  subscriptionManagement: "Subscription management",
  subscriptionDescription: "View and modify your subscription",
  currentPlan: "Current plan",
  noSubscription: "No active subscription",
  manageSubscription: "Manage my subscription",
  chooseSubscription: "Choose a subscription",
  perMonth: "/month",

  feature1: "Manage your plan and limits",
  feature2: "Upgrade or downgrade",
  feature3: "Cancel your subscription anytime",

  // Invoices & Payments
  invoicesPayments: "Invoices and payments",
  invoicesDescription: "Access your invoices and history",
  stripePortalDescription: "The Stripe portal allows you to easily manage all aspects of your billing securely.",

  portalFeature1: "Download your invoices",
  portalFeature2: "Update your payment methods",
  portalFeature3: "View billing history",
  portalFeature4: "Manage billing information",

  openStripePortal: "Open Stripe portal",
  requiresSubscription: "Requires an active subscription",
  loading: "Loading...",

  // Security
  securityTitle: "Secure payments",
  securityDescription: "All transactions are secured by Stripe, the world leader in online payments. Your banking information is never stored on our servers."
}

export const stripe = {
  title: "Stripe Connect",
  description: "Set up your Stripe account to receive payments from your clients",
  loading: "Loading...",

  // Account Status
  accountStatus: "Your account status",
  accountStatusDescription: "Information about your Stripe Connect account",

  // Status badges
  status: {
    notConfigured: "Not configured",
    pending: "Under verification",
    verified: "Verified",
    restricted: "Restricted"
  },

  // Capabilities
  capabilities: {
    charges: "Accept payments",
    chargesEnabled: "You can accept payments",
    chargesDisabled: "Not enabled",
    payouts: "Receive payouts",
    payoutsEnabled: "You can receive payouts",
    payoutsDisabled: "Not enabled",
    details: "Information submitted",
    detailsSubmitted: "Complete information",
    detailsNotSubmitted: "Missing information"
  },

  // Requirements
  requirements: {
    pastDue: "Immediate action required",
    pastDueDescription: "Some information is overdue. Please complete your account to continue accepting payments.",
    currentlyDue: "Required information",
    currentlyDueDescription: "Please complete your account to enable all services."
  },

  // Buttons
  button: {
    configureStripe: "Configure Stripe",
    completeOnboarding: "Complete setup",
    openDashboard: "Open Stripe dashboard"
  },

  // Not configured state
  notConfigured: {
    title: "Stripe account not configured",
    description: "Set up your Stripe Connect account to start receiving online payments from your clients. The process is simple and secure."
  },

  // Fees information
  fees: {
    title: "Transaction fees",
    description: "How do payment fees work?",
    modes: "Fee management modes",
    mode1Title: "I absorb service fees",
    mode1Description: "The client pays only the service price. Service fees (~1.5% + €0.25) are deducted from your revenue.",
    mode2Title: "I pass fees to the client",
    mode2Description: "A 2% markup is added to the price to cover service fees. You receive 100% of the service price.",
    stripe: "Service fees: ~1.5% + €0.25",
    stripeDescription: "Service fees are added to the service amount and paid by the client. You receive 100% of your service price.",
    platform: "Platform commission: €0",
    platformDescription: "No commission is charged by PrestaSlot. You keep the full amount of your services.",
    changeSetting: "Switch modes",
    changeSettingDescription: "You can switch between the two modes at any time via the \"Transaction fee management\" toggle on this page."
  },

  // Pricing example
  example: {
    title: "Pricing example",
    servicePrice: "Service price",
    stripeFee: "Service fees (added to total)",
    clientPays: "Client pays",
    youReceive: "You receive"
  },

  // Revenue statistics
  revenueStats: {
    title: "Revenue statistics",
    totalRevenue: "Total revenue",
    totalTransactions: "Number of payments",
    averageTransaction: "Average amount",
    totalStripeFees: "Service fees"
  }
}

export const payment = {
  // Common
  verifying: "Verifying payment...",
  pleaseWait: "Please wait",
  error: "Error",
  backToHome: "Back to home",

  // Success page
  successTitle: "Payment successful!",
  successMessage: "Your payment has been processed successfully",
  details: "Payment details",
  amount: "Amount",
  status: "Status",
  paymentId: "Payment ID",
  paid: "Paid",
  confirmationEmail: "A confirmation email has been sent to your email address with all the details of your booking.",
  viewBooking: "View my booking",
  bookAnother: "Book another appointment",

  // Cancel page
  cancelTitle: "Payment cancelled",
  cancelMessage: "You have cancelled the payment process",
  whatHappensNow: "What happens now?",
  cancelInfo1: "Your booking has not been confirmed",
  cancelInfo2: "No amount has been charged from your account",
  cancelInfo3: "You can resume the booking process at any time",
  cancelledPaymentDetails: "Cancelled payment details",
  cancelled: "Cancelled",
  needHelp: "Need help? Contact us if you encounter difficulties during the payment process.",
  tryAgain: "Try again",
  backToBooking: "Booking page",
  loading: "Loading...",
}
